import { render, staticRenderFns } from "./SeasonChart.vue?vue&type=template&id=1754e512"
import script from "./SeasonChart.vue?vue&type=script&lang=js"
export * from "./SeasonChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports